import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import ManageRight from "../Layouts/ManageRight";



export default function ManageAddress() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <ManageRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}

